import React, { forwardRef } from "react";
import "./modal.css";

interface ModalBodyProps {
  children: React.ReactNode;
}

const ModalBody = forwardRef<HTMLDivElement, ModalBodyProps>(
  ({ children }, ref) => {
    return (
      <div ref={ref} className="app-modal--body">
        {children}
      </div>
    );
  }
);

export default ModalBody;
